import * as _isEmpty from 'lodash/isEmpty';

export function isEmpty(value) {
    return _isEmpty(value);
}
